{
  "familyId": "SWW-TT-INV-JIJ",
  "questions": [
    {
      "id": "SWW-TT-INV-JIJ-001",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "multiple_choice",
      "question": "Morgen ... jij naar de tandarts. (gaan)",
      "context": null,
      "options": ["ga", "gaat", "ging", "gegaan"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Inversie Regel", "content": "Bij inversie staat 'jij' ACHTER het werkwoord. Dan gebruik je alleen de stam (geen -t): ga jij, loop jij, werk je.", "icon": "lightbulb" }
        }
      ],
      "conceptId": "present_tense_inversion_jij",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: inversieregel. Stap 1: Bij inversie (omkering) staat 'jij' ACHTER het werkwoord. Stap 2: Dan valt de -t weg en gebruik je alleen de stam. Stap 3: De stam van 'gaan' is 'ga'. Dus: '... ga jij ...' (niet 'gaat jij'). Vergelijk: 'Jij gaat' → 'Ga jij?'",
        "distractorExplanations": {
          "0": "Correct! Inversieregel: bij inversie met 'jij' gebruik je alleen de stam: ga (zonder -t).",
          "1": "Veelgemaakte fout: de -t laten staan bij inversie. 'Gaat' is de gewone jij-vorm ('Jij gaat'), maar bij inversie valt de -t weg: 'Ga jij?' Misconceptie: vergeten dat inversie de -t laat wegvallen.",
          "2": "Veelgemaakte fout: verleden tijd gebruiken in plaats van tegenwoordige tijd. 'Ging' is de verleden tijd. Het signaalwoord 'morgen' wijst op de toekomst, dus tegenwoordige tijd: ga.",
          "3": "Veelgemaakte fout: voltooid deelwoord gebruiken zonder hulpwerkwoord. 'Gegaan' hoort bij 'ben gegaan'. Hier is geen hulpwerkwoord, dus gewoon tegenwoordige tijd: ga."
        }
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-002",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "text_highlight",
      "question": "Klik op het woord met een inversie-fout:",
      "context": "Loopt jij ook mee naar de winkel?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Loopt jij ook mee naar de winkel?",
        "correctHighlights": [{"start": 0, "end": 5}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Inversie Regel", "content": "Bij inversie staat 'jij' ACHTER het werkwoord. Dan valt de -t weg: Loop jij? (niet Loopt jij).", "icon": "lightbulb" }
        }
      ],
      "conceptId": "inversion_error_text_highlight",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "'Loopt' is fout bij inversie met 'jij'. De inversieregel zegt: jij achter werkwoord = geen -t. Dus: Loop jij (niet Loopt jij). Vergelijk: 'Jij loopt' → 'Loop jij?'",
        "distractorExplanations": {
          "0": "Correct! 'Loopt' moet 'Loop' zijn. Bij inversie met jij valt de -t weg: Loop jij?"
        }
      }
    }
  ]
}
